import React from 'react'

import useStyles from './styles'

const HeaderInfo = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div>Read only</div>
      <div className={classes.info}>
        This is not your task, so you cannot edit it.
      </div>
    </div>
  )
}

export default HeaderInfo
